import script from "./AtomChartQuadrant.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomChartQuadrant.vue?vue&type=script&lang=ts&setup=true"

import "./AtomChartQuadrant.vue?vue&type=style&index=0&id=3b9a2792&lang=css"

const __exports__ = script;

export default __exports__